module.exports = __webpack_public_path__ + "img/icon-oven.db6e467c.svg";